export interface ISnapshot {

  form: string
  state: ISnapshotState
  LOCALSTORAGEKEY: string
  CURRENTFISCALID: string
  CURRENTUSERID: string

  retrieveData(): any
  isDataChanged(): Promise<boolean>
  takeSnapshot(type: SnapshotTypes, that: ISnapshot): void
  restoreSnapshot(type: SnapshotTypes): any
  addToLocalStorage(data: ISnapshotData): void
  getLocalStorage(): any
  setInterval(): void
  tryFlush(userId: string, fiscalPeriodId: string): void
  forceFlush(): void
  getState(): ISnapshotState
  clearInterval(intervalId: number): void
  userHasSnapshot(type: SnapshotTypes): boolean
}

export interface ISnapshotState {
  timeInSeconds: number
  initialized: boolean
  intervalId: number
  snapshotsTaken: number
}

export interface ISnapshotData {
  date: string
  form: string
  type: SnapshotTypes
  data: any
}

export interface ISanpshotInitializer {
  form: string
  retrieveData(): any
  isDataChanged(): Promise<boolean>
}

export enum SnapshotTypes {
  MANUAL = 'Manual',
  AUTOMATIC = 'Automatic'
}